"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        button: {
            borderRadius: theme.spacing(2.5),
            fontWeight: utils_1.textWeightMap.bold,
            height: theme.spacing(5),
            padding: 0,
            width: 0,
            minWidth: 0,
            transition: 'width 0.4s linear, padding 0.6s ease-out',
            '&:hover': {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(7),
                transition: 'width 0.4s linear, padding 0.6s ease-out',
                width: '100%',
            },
            '& .MuiButton-label': {
                overflow: 'hidden',
            },
        },
        icon: function (_a) {
            var color = _a.color;
            var paletteColor = null;
            if (['primary', 'secondary'].indexOf(color) > -1) {
                // @ts-ignore:next-line
                paletteColor = color;
            }
            var backgroundColor = paletteColor ? theme.palette[paletteColor] : theme.palette.info;
            return {
                position: 'absolute',
                right: '-1em',
                width: theme.spacing(7),
                height: theme.spacing(7),
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: backgroundColor.main,
                boxShadow: '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
                '&:hover': {
                    backgroundColor: backgroundColor.dark,
                },
            };
        },
        label: {
            whiteSpace: 'nowrap',
        },
    });
});
